import { Button } from '~/design-system/elements/Button/Button';
import { DeckIcon } from '~/design-system/elements/DeckIcon/DeckIcon';
import { Icon } from '~/design-system/elements/Icon/Icon';
import { Tooltip } from '~/design-system/components/Tooltip/Tooltip';
import styles from './WebSearchToggleButtonUI.module.css';

export interface WebSearchToggleButtonUIProps {
  enabled?: boolean;
  onToggle?: (next: boolean) => void;
  disabled?: boolean;
}

export function WebSearchToggleButtonUI({
  enabled = false,
  onToggle,
  disabled = false,
}: WebSearchToggleButtonUIProps) {
  const tooltipContent = enabled
    ? 'Search the web is ON for the next message'
    : 'Search the web';

  const leadIcon = enabled ? (
    <span className={styles.leadIconSwap}>
      <Icon name="global-line" size="button-xs" className={styles.leadIconDefault} />
      <DeckIcon name="close" size="button-xs" className={styles.leadIconHover} />
    </span>
  ) : (
    'global-line'
  );

  return (
    <Tooltip content={tooltipContent} side="top">
      <Button
        type="button"
        variant="ghostMuted"
        size={enabled ? 'xs' : 'icon-xs'}
        leadIcon={leadIcon}
        aria-label={enabled ? 'Turn off web search' : 'Toggle web search'}
        aria-pressed={enabled}
        onClick={() => onToggle?.(!enabled)}
        disabled={disabled}
        className={enabled ? styles.enabled : undefined}
      >
        {enabled ? 'Search' : undefined}
      </Button>
    </Tooltip>
  );
}
